<template>
  <div id="app">
    <div v-if="this.$store.getters.auth">
      <a-layout id="layout-main" class="layout">
        <a-layout-sider v-model="collapsed" width="250" :trigger="null" collapsible>
          <div class="logo">
            <img src="/images/logo.svg" alt="BPI MS" class="imgLogo"/>
          </div>
          <span v-if="isSysAd">
            <navigationSystemAdmin />
          </span>
          <span v-else>
            <navigation />
          </span>
        </a-layout-sider>
        <a-layout>
          <a-layout-header>
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <div style="float: right; margin-right: 1.5em;">
              <!-- Accounting Period -->
              <a-dropdown v-if="showDate">
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="showPeriodModal"> Select Period </a-menu-item>
                  <a-menu-item key="2" v-if="roles.includes('Reviewer') && OpenPeriod" @click="showPeriodCloser"> Close Period </a-menu-item>
                </a-menu>
                <a-button class="no-blue" type="link" ghost style="margin-left: 8px; margin-right: 1em;color: #000"> {{ moment(String(selectedPeriod)).format('MMMM YYYY') }}<a-icon type="down" /> </a-button>
              </a-dropdown>

              <!-- Notifications -->
              <span v-if="totalNotifs > 0 || withPendingPeriod" style="font-weight: bold; color: red;">*</span><a-icon v-if="roles.includes('Approver')" type="bell" @click="showNotifications" title="PENDING FOR APPROVAL" style="margin-right: 0.5em;"/>
              <a-icon type="user" @click="showAccountDetails" title="MY ACCOUNTS"/>
            </div>
          </a-layout-header>
          <a-layout-content>
            <router-view />
          </a-layout-content>
        </a-layout>
      </a-layout>


      <a-modal :visible="periodCloserModal" title="Close Period" @cancel="hidePeriodCloser" @ok="closePeriodToPending">
        <a-alert
          class="mb-2"
          message="Note"
          type="warning"
          show-icon
        >
          <span slot="description">
            Closing the period will lock uploading and processing. New transactions will be posted within the newly-stated period.
          </span>
        </a-alert>
        <p>You are about to close the following period. Would you like to proceed?</p>
        <a-descriptions layout="vertical" class="mb-2" bordered>
          <a-descriptions-item label="MONTH">
            {{ formClosePeriod.FR_MONTH }}
          </a-descriptions-item>
          <a-descriptions-item label="YEAR">
            {{ formClosePeriod.FR_YEAR }}
          </a-descriptions-item>
        </a-descriptions>
      </a-modal>
    </div>
    <div v-else>
      <router-view />
    </div>
    <!-- -----------------------------SELECT PERIOD MODAL---------------------------- -->
    <a-modal
      :visible="showModal"
      :width="420"
      title="Select Period"
      footer=""
      closeButton=""
    >
      <a-form-model layout="inline">
        <a-row>
          <a-form-model-item>
            <label>Select Year: </label>
            <a-select
              v-model="formPeriod.FR_YEAR"
              style="width: 370px"
              v-bind:id="'selectYear'"
              @change="checkSelectedYear"
            >
              <a-select-option v-for="year in rowYear" v-bind:key="year.value">{{ year.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-form-model-item>
            <label>Select Month: </label>
            <a-select
              v-model="formPeriod.FR_MONTH"
              style="width: 370px"
              :disabled="withoutSelectedYear"
              v-bind:id="'selectMonth'"
              @select="checkSelectedPeriod"
            >
              <a-select-option v-for="month in rowMonth" v-bind:key="month.value">{{ moment(String(month.value + ' 2021')).format('MMMM') }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-row>
        <a-row>
          <div style="text-align:right">
            <a-form-model-item>
              <a-button type="primary" ghost style="text-align:right; margin-right: 2px;" @click="selectPeriodModal" title="Open Period" :disabled="open">
                <a-icon type="check" />Open
              </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button type="primary" ghost style="text-align:right; margin-right: 2px;" @click="addPeriod" title="Add Period">
                <a-icon type="plus" />Add
              </a-button>
            </a-form-model-item>
          </div>
        </a-row>
      </a-form-model>     
    </a-modal>
    <!-- --------------------------ADD PERIOD MODAL---------------------------- -->
    <a-modal
      :visible="showAddPeriodModal"
      :width="420"
      title="Add Period"
    >
      <a-form-model layout="inline">
        <a-row>
          <a-form-model-item>
            <label>Select Year: </label>
            <a-select
              v-model="formAddPeriod.FR_YEAR"
              style="width: 370px"
            >
              <a-select-option :value="moment().add(-5, 'years').format('YYYY')" >{{moment().add(-5, 'years').format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().add(-4, 'years').format('YYYY')" >{{moment().add(-4, 'years').format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().add(-3, 'years').format('YYYY')" >{{moment().add(-3, 'years').format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().add(-2, 'years').format('YYYY')" >{{moment().add(-2, 'years').format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().add(-1, 'years').format('YYYY')" >{{moment().add(-1, 'years').format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().format('YYYY')" >{{moment().format('YYYY')}}</a-select-option>
              <a-select-option :value="moment().add(1, 'years').format('YYYY')" >{{moment().add(1, 'years').format('YYYY')}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-form-model-item>
            <label>Select Month: </label>
            <a-select
              v-model="formAddPeriod.FR_MONTH"
              style="width: 370px"
            >
              <a-select-option :value="'Jan'" >January</a-select-option>
              <a-select-option :value="'Feb'" >February</a-select-option>
              <a-select-option :value="'Mar'" >March</a-select-option>
              <a-select-option :value="'Apr'" >April</a-select-option>
              <a-select-option :value="'May'" >May</a-select-option>
              <a-select-option :value="'Jun'" >June</a-select-option>
              <a-select-option :value="'Jul'" >July</a-select-option>
              <a-select-option :value="'Aug'" >August</a-select-option>
              <a-select-option :value="'Sep'" >September</a-select-option>
              <a-select-option :value="'Oct'" >October</a-select-option>
              <a-select-option :value="'Nov'" >November</a-select-option>
              <a-select-option :value="'Dec'" >December</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-row>
      </a-form-model> 
      <template slot="footer">
        <a-button key="back" @click="hideAddPeriodModal">
          Return
        </a-button>
        <a-button key="submit" type="primary" ghost :loading="loading" @click="saveNewEntry">
          Submit
        </a-button>
      </template>    
    </a-modal>
    <!-- --------------------PENDING APPROVAL MODAL FOR NEWLY CREATED ACCOUNTS---------- -->
    <a-modal
      :visible="pendingForApprovalVisible"
      :width="1020"
      title="Pending for Approvals"
      @ok="hideApprovalModal"
      @cancel="hideApprovalModal"
    >
      <a-table
          :columns="pendingApprovalColumn"
          :data-source="pendingApprovalRow"
          row-key="index"
          :pagination="false"
          >
          <a slot="actions" slot-scope="row">
            <a-popconfirm
              title="Are you sure you want to revoke the access privileges of this user?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="() => lockUser(row.username)"
            >
              <a-button type="danger" ghost title="Reject" style="margin-right: 5px">
                <a-icon type="close" />
              </a-button>
            </a-popconfirm>
            <a-popconfirm
              title="Are you sure you want to activate the access privileges of this user?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="() => activateUser(row.username)"
            >
              <a-button type="primary" ghost title="Activate" >
                <a-icon type="check" />
              </a-button>
            </a-popconfirm>
          </a>
      </a-table>      
    </a-modal>

    <!-- ----------------CLOSING OF PERIOD MODAL------------ -->
    <a-modal
      :visible="closingOfPeriodApprovalVisible"
      :width="845"
      title="Closing of Period Approval"
      @ok="hideClosingApprovalModal"
      @cancel="hideClosingApprovalModal"
    >
      <a-table
          :columns="periodColumn"
          :data-source="periodRow"
          row-key="index"
          :pagination="false"
          >
          <a slot="actions" slot-scope="row">
            <a-popconfirm
              title="Are you sure you want to reject the closing of this period?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="() => rejectClosing(row.FR_MONTH, row.FR_YEAR)"
            >
              <a-button type="danger" ghost title="REJECT" style="margin-right: 5px">
                <a-icon type="close" />
              </a-button>
            </a-popconfirm>
            <a-popconfirm
              title="Are you sure you want approve the closing of this period?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="() => approveClosing(row.FR_MONTH, row.FR_YEAR)"
            >
              <a-button type="primary" ghost title="APPROVE" >
                <a-icon type="check" />
              </a-button>
            </a-popconfirm>
          </a>
      </a-table>      
    </a-modal>

    <!-- -------------------------------Notification Drawer------------------------ -->
    <a-drawer
        title="Notifications"
        placement="right"
        :closable="false"
        :visible="notificationVisible"
        @close="onClose"
        width="420"
      >
      <ul>
        <li v-if="withPendingPeriod">
          <h4 style="cursor: pointer; color: #10b2e4" @click="showClosingPeriodApprovalModal">Pending approval for the closing of Period. Click to see more details!</h4>
        </li>
        <li v-if="totalNotifs > 0">
          <h4 style="cursor: pointer; color: #10b2e4" @click="showPendingApprovalModal">Total of {{totalNotifs}} newly created account pending for approval</h4>
        </li>
      </ul>
      </a-drawer>
      <a-drawer
        title="My Accounts"
        placement="right"
        :closable="false"
        :visible="myAccountsVisible"
        @close="onClose"
        width="420"
      >
        <div class="text-left" style="margin-bottom: 1em;">
          <p ><b>Username: </b>{{ rows.username }}</p>
          <p ><b>Full Name: </b>{{ rows.full_name }}</p>
          <p ><b>Email: </b>{{ rows.email }}</p>
          <p ><b>Roles: </b>{{ roles_desc }}</p>
          <p ><b>Function: </b>{{ function_desc }}</p>
          <p ><b>Status: </b>{{ rows.status }}</p>
        </div>  
            
        <a-button type="default" @click="showChangePassForm">
          <a-icon type="save" />
            Change Password
        </a-button>
      </a-drawer>
      <!-- ----------------------CHANGE PASSWORD MODAL------------------- -->
      <a-modal
      :visible="changePassVisible"
      :width="500"
      title="Change Password"
      ok-text="Save"
      :footer=null
      @cancel="hideChangePassForm">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="Old Password" prop="oldPass">
            <a-input-password v-model="form.oldPass" type="password" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item label="Password" prop="pass">
            <a-input-password v-model="form.pass" type="password" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item label="Confirm" prop="checkPass">
            <a-input-password v-model="form.checkPass" type="password" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button style="float: right" @click="resetForm('form')" >
              Reset
            </a-button>
            <a-button type="primary" ghost @click="saveChanges('form')" style="float: right; margin-right: 10px">
              Submit
            </a-button>
          </a-form-model-item>
        </a-form-model>
    </a-modal> 
  </div>
</template>
<script>
import apiClient from './api.js'
// import qs from 'qs'
import Navigation from './components/Navigation.vue'
import NavigationSystemAdmin from './components/NavigationSystemAdmin.vue'
import moment from 'moment'
export default {
  components: {
    'navigation': Navigation,
    'navigationSystemAdmin': NavigationSystemAdmin
  },
  data () {
    let validatePass = (rule, value, callback) => {
      var format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/

      var num = /\d/

      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if(value.toUpperCase() === value || value.toLowerCase() === value || !format.test(value) || !num.test(value) || value.length < 8){
          callback(new Error('Password must be atleast 8 characters long. Password must contain an uppercase, lowercase and atleast 1 special and numeric character/s!'));
        }

        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.form.pass) {
        callback(new Error("Passwords doesn't match!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      OpenPeriod: false,
      addYear: [],
      closingOfPeriodApprovalVisible: false,
      CURRENT_PERIOD_STATUS: '',
      totalNotifs: '',
      collapsed: false,
      periodCloserModal: false,
      showModal: false,
      showAddPeriodModal: false,
      pendingForApprovalVisible: false,
      selectedValues: [],
      formPeriod: {},
      formAddPeriod: {},
      formClosePeriod: {
        FR_MONTH: '',
        FR_YEAR: ''
      },
      showDate: false,
      myAccountsVisible: false,
      periods: [
        {
          Value: 'November 2021',
          Text: 'November 2021'
        },
        {
          Value: 'December 2021',
          Text: 'December 2021'
        }
      ],
      notificationVisible: false,
      APRows: [],
      rowYear: [],
      rowMonth: [],
      yearMonth: [],
      selectedPeriod: '',
      changePassVisible: false,
      form: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rows: [],
      roles: [],
      roles_desc: '',
      isSysAd: false,
      withPendingPeriod: false,
      withoutSelectedYear: true,
      function_desc: '',
      periodRow: [],
      periodColumn: [
        {
          key: 'FR_MONTH',
          dataIndex: 'FR_MONTH',
          title: 'Month'
        },
        {
          key: 'FR_YEAR',
          dataIndex: 'FR_YEAR',
          title: 'Year'
        },
        {
          key: 'STATUS_CD',
          dataIndex: 'STATUS_CD',
          title: 'Status'
        },
        {
          key: 'UPDATED_BY',
          dataIndex: 'UPDATED_BY',
          title: 'Requested By'
        },
        {
          key: 'actions',
          title: 'Actions',
          align: 'center',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      pendingApprovalRow: [],
      pendingApprovalColumn: [
        {
          key: 'username',
          dataIndex: 'username',
          title: 'Username'
        },
        {
          key: 'full_name',
          dataIndex: 'full_name',
          title: 'Full Name'
        },
        {
          key: 'email',
          dataIndex: 'email',
          title: 'Email'
        },
        {
          key: 'roles',
          dataIndex: 'roles',
          title: 'Roles'
        },
        {
          key: 'func',
          dataIndex: 'func',
          title: 'Function'
        },
        {
          key: 'status',
          dataIndex: 'status',
          title: 'Status'
        },
        {
          key: 'actions',
          title: 'Actions',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'actions' }
        }
      ],
      rules: {
        pass: [{ validator: validatePass, trigger: 'change' }],
        checkPass: [{ validator: validatePass2, trigger: 'change' }]
      },
      open: true,
    }
  },
  methods: {
    showPeriodModal (){
      var years = ''

      apiClient.get('/ap')
      .then(resp => {
        this.APRows = resp.data
        // this.loading = false
        
        for (var x = 0; x < this.APRows.length; x++){
          var row = this.APRows[x];

          //check if the year is existing on the dropdown option
          var checkYear = this.rowYear.filter(function (year) {
           if (year.value == row.FR_YEAR) {
                   return row.FR_YEAR;
              }
          });

          if(checkYear.length == 0){
            this.rowYear.push({text: this.APRows[x].FR_YEAR, value: this.APRows[x].FR_YEAR});
            years += this.APRows[x].FR_YEAR + ','
          }

          this.rowYear.sort((a, b) => moment(a.value, 'YYYY').diff(moment(b.value, 'YYYY')))

          this.yearMonth.push({year: this.APRows[x].FR_YEAR, month: this.APRows[x].FR_MONTH});
        }

        localStorage.setItem('Periods', years)
        
      });

      this.showModal = true;
    },
    checkSelectedYear() {
      this.rowMonth = [];

      for(var i = 0; i < this.yearMonth.length; i++){
        if(this.yearMonth[i].year == this.formPeriod.FR_YEAR){
          this.rowMonth.push({text: this.yearMonth[i].month, value: this.yearMonth[i].month});
        }
      }
      
      this.rowMonth.sort((a, b) => moment(a.value, 'MMMM').diff(moment(b.value, 'MMMMM')))

      this.withoutSelectedYear = false;
    },
    showAccountDetails () {
      
      this.myAccountsVisible = true;
    },
    showPendingApprovalModal (){
      this.onClose();
      this.pendingForApprovalVisible = true;
    },
    showClosingPeriodApprovalModal (){
      this.closingOfPeriodApprovalVisible = true;
      this.onClose();
    },
    hideClosingApprovalModal (){
      this.closingOfPeriodApprovalVisible = false;
    },
    async selectPeriodModal (){
      var year = this.formPeriod.FR_YEAR;
      var month = this.formPeriod.FR_MONTH;
      apiClient.post('/ap/period', {FR_YEAR: year, FR_MONTH: month})
        .then(resp => {
          this.selectedPeriod = month + " " + year;
          localStorage.setItem( 'ShowModal', 'false' );
          localStorage.setItem( 'SelectedMonth', month );
          localStorage.setItem( 'SelectedYear', year );
          localStorage.setItem( 'PERIOD_STATUS', resp.data.STATUS_CD );
        })
        .catch(() => {
          this.$notification['error']({
            message: 'Error',
            description: 'Failed to fetch data from the server. Please refresh the page and try again.'
          })
        })
        .finally(() => {
          this.showModal = false;
          window.location.href = '/';
        })
    },
    hidePeriodModal (){
      this.showModal = false;
    },
    addPeriod (){
      this.showModal = false;
      this.showAddPeriodModal = true;
    },
    hideAddPeriodModal (){
      this.showAddPeriodModal = false;
      this.showModal = true;
      this.formAddPeriod.FR_MONTH = '';
      this.formAddPeriod.FR_YEAR = '';
    },
    async showPeriodCloser() {
      this.formClosePeriod.FR_MONTH = localStorage.getItem('SelectedMonth');
      this.formClosePeriod.FR_YEAR = localStorage.getItem('SelectedYear');
      this.periodCloserModal = true
      
    },
    hidePeriodCloser() {
      this.periodCloserModal = false
    },
    async closePeriodToPending() {
      let HERE = this
      var year = this.formClosePeriod.FR_YEAR;
      var month = this.formClosePeriod.FR_MONTH;

      var params = {FR_YEAR: year, FR_MONTH: month}

      let url = localStorage.getItem('baseURL') + 'ap/close?status=Pending'

      let xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'))
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = () => {
        if(xhr.status != 200){
          HERE.loading = false
          let x = JSON.parse(xhr.response)
          console.log(xhr.response)
          HERE.$notification['error']({
            message: 'Error',
            description: x.detail
          })
        }
        else{
          HERE.hidePeriodCloser();
        }
      };
      xhr.send(JSON.stringify(params));
    },
    async approveClosing(FR_MONTH, FR_YEAR) {
      let HERE = this

      var url = localStorage.getItem('baseURL') + 'ap/close?status=Closed'

      let params = {
        FR_YEAR: FR_YEAR, FR_MONTH: FR_MONTH
      }

      let xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'))
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      
      xhr.onload = () => {

        if(xhr.status != 200){
          let x = JSON.parse(xhr.response)
          
          HERE.$notification['error']({
            message: 'Error',
            description: x.detail
          })
        }
        else{
          HERE.hidePeriodCloser();
          location.reload();
        }
      };
      xhr.send(JSON.stringify(params));
    },
    async rejectClosing(FR_MONTH, FR_YEAR) {

      let HERE = this

      var url = localStorage.getItem('baseURL') + 'ap/close?status=Open'

      let params = {
        FR_YEAR: FR_YEAR, FR_MONTH: FR_MONTH
      }

      let xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'))
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      
      xhr.onload = () => {

        if(xhr.status != 200){
          let x = JSON.parse(xhr.response)
          
          HERE.$notification['error']({
            message: 'Error',
            description: x.detail
          })
        }
        else{
          HERE.hidePeriodCloser();
          location.reload();
        }
      };
      xhr.send(JSON.stringify(params));

    },
    async saveNewEntry (){
      let here = this

      this.loading = true
      var year = this.formAddPeriod.FR_YEAR;
      var month = this.formAddPeriod.FR_MONTH;

      var params = {FR_YEAR: year, FR_MONTH: month}

      let url = localStorage.getItem('baseURL') + 'ap/open'

      let xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'))
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      
      xhr.onload = () => {
        if(xhr.status != 200){
          here.loading = false
          let x = JSON.parse(xhr.response)
          console.log(xhr.response)
          this.$notification['error']({
            message: 'Error',
            description: x.detail
          })
        }
        else{
          here.loading = false
          this.$notification['success']({
            message: 'Success',
            description: 'Successfully add new period!'
          })
          here.hideAddPeriodModal()
        }
      };
      xhr.send(JSON.stringify(params));
      
    },
    ifShowModal (){
      var val = localStorage.getItem( 'ShowModal' );
      if (val == 'true') {
        this.showPeriodModal();
      }else{
        this.hidePeriodModal();
        var month = localStorage.getItem( 'SelectedMonth' );
        var year = localStorage.getItem( 'SelectedYear' );
        this.selectedPeriod = month + " " + year;
        this.showDate = true;
      }
    },
    showNotifications (){
      this.notificationVisible = true;
    },
    hideApprovalModal (){
      this.pendingForApprovalVisible = false;
    },
    async loadNotifications (){
      this.pendingApprovalRow = [];
      
      apiClient.get('/user/pendingapproval')
      .then(resp => {
        this.totalNotifs = resp.data.length;
        for(var i = 0; i < resp.data.length; i++){
          var roles_description = '';
          var funcs_desc = ''
          for (var j = 0; j < resp.data[i].roles_with_names.length; j++){
            roles_description += resp.data[i].roles_with_names[j] + " ";
          }

          for (var x = 0; x < resp.data[i].roles_with_names.length; x++){
            funcs_desc += resp.data[i].roles_with_names[x] + " ";
          }

          resp.data[i].roles = roles_description;
          resp.data[i].func = funcs_desc;
          resp.data[i].index = i;
          this.pendingApprovalRow.push(resp.data[i]);
        }
        
      })
      .catch((error) => {
        console.log(error)
      })

      apiClient.get('/ap')
      .then(resp => {

        this.periodRow = [];

        for (var i = 0; i < resp.data.length; i++)
        {
          resp.data.index = i;
          
          if(resp.data[i].STATUS_CD == 'Pending')
          {
            this.withPendingPeriod = true;
            this.periodRow.push(resp.data[i]);
          }
        }
        
      });
    },
    onClose () {
      this.notificationVisible = false;
      this.myAccountsVisible = false;
    },
    showChangePassForm() {
      this.changePassVisible = true
      this.onClose();
    },
    saveChanges(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          apiClient.post('/user/reset_password',
          {
            username: this.rows.username,
            email: this.rows.email,
            full_name: this.rows.full_name,
            status: this.rows.status,
            roles_with_names: this.rows.roles_with_names,
            funcs_with_names: this.rows.funcs_with_names,
            old_password: this.form.oldPass,
            new_password: this.form.pass
          })
          .then(resp => {
            console.log(resp);
            this.form = {}
            this.changePassVisible = false
          })
          .catch((error) => {
            console.log(error);
            this.$notification['error']({
              message: 'Error',
              description: 'Submit error!'
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    hideChangePassForm() {
      this.changePassVisible = false
    },
    async lockUser(username) {
      var parameter = "?username=" + username;
      let here = this
      
      apiClient.post('/user/approver/suspend' + parameter)
      .then(resp => {
        here.userRoles = resp.data
        here.autoExpandParent = true
        here.reloadTable();
        here.showPendingApprovalModal = false;
        location.reload();
        // this.loading = false
      })
    },
    async activateUser(username){
      var parameter = "?username=" + username;
      let here = this

      apiClient.post('/user/approver/activate'+parameter)
      .then(resp => {
        here.userRoles = resp.data
        here.autoExpandParent = true
        // this.loading = false
      })
      .finally(() => {
        here.reloadTable();
        here.showPendingApprovalModal = false;
        location.reload();
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    checkSelectedPeriod(){
      this.open = false
    },
  },
  mounted () {

    if (this.$router.history.current.path != '/login') {
      // Check if token is valid
      apiClient.get('/user/me')
      .then(resp => {
        localStorage.setItem( 'roles_with_names', resp.data.roles_with_names );
        localStorage.setItem( 'funcs_with_names', resp.data.funcs_with_names );
        localStorage.setItem( 'userStatus', resp.data.status )

        this.rows = resp.data
        // this.loading = false
        this.roles = this.rows.roles_with_names

        if(resp.data.roles_with_names.includes('Approver')){
          this.loadNotifications()
        }

        for(var i = 0; i < this.roles.length; i++){
          if((i + 1) === this.roles.length){
            this.roles_desc += this.roles[i]
          }else{
            this.roles_desc += this.roles[i] + ", "
          }
        }

        var func = resp.data.funcs_with_names;

        for(var j = 0; j < func.length; j++){
          if((j + 1) === func.length){
            this.function_desc += func[j]
          }else{
            this.function_desc += func[j] + ", "
          }
        }

        if(resp.data.roles_with_names.includes("System Admin")){
          this.isSysAd = true;
        }
      })
      .catch(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('ShowModal')
        this.state.auth = false
        window.location.href = '/login'
      })
    }

    this.ifShowModal()

    if(localStorage.getItem('PERIOD_STATUS') != '' && localStorage.getItem('PERIOD_STATUS') != null)
      if(localStorage.getItem('PERIOD_STATUS') == 'Open')
        this.OpenPeriod = true
  }
}
</script>